<template>
    <div class="MAM_flowCard">
        <el-dialog
            title="流量卡模版配置"
            width="800px"
            :visible="flowCard.isShow"
            :close-on-click-modal="false"
            @close="handleClose"
        >
            <!-- 活动说明 -->
            <!-- <el-tooltip class="item" effect="dark" placement="right-start"> -->
            <el-button type="text" style="color:#606266;font-weight:700">流量卡模版配置</el-button>
            <div style="margin-top:10px">
              <el-tag type="danger">首年扣费：流量卡的有效期按照品牌机构平台入库时间（机具管理—库存管理）+300天算（为首年结束日）</el-tag>
            </div>
          <!-- </el-tooltip> -->
            <!-- 表单部分 -->
            <el-form label-position="top" label-width="80px" :model="flowCardForm">
                <el-form-item>
                    <el-table :data="setting" border max-height="456px">
                        <el-table-column
                            header-align="center"
                            align="center"
                            min-width="100"
                            prop="is_default"
                            label="默认值"
                        >
                            <template slot-scope="scope">
                                <el-checkbox
                                    v-model="scope.row.is_default"
                                    :true-label="1"
                                    :false-label="0"
                                    :disabled="scope.row.status == 0"
                                    @change="handleDefault(scope.$index)"
                                ></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column
                            header-align="center"
                            align="center"
                            width="120"
                            type="index"
                            label="模板ID"
                        ></el-table-column>


                        <el-table-column
                            header-align="center"
                            align="center"
                            min-width="120"
                            prop="target_money"
                            label="流量扣费"
                        >
                            <template slot-scope="scope">
                                <!-- <el-input
                                    :disabled="scope.row.brand_reward_conf_id != '' && flowCardForm.type == 5"
                                    v-model="scope.row.target_money"
                                ></el-input> -->
                                <el-select v-model="scope.row.target_money" @change="((val)=>changeFee(val,scope.row))" placeholder="请选择">
                                    <el-option v-for="item in comm_fee_list" 
                                    :key="item.ruleId" :label="item.description"
                                    :value="item" 
                                    :disabled="scope.row.brand_reward_conf_id != '' && flowCardForm.type == 5"
                                    >
                                   </el-option>
                                </el-select>   
                            </template>
                        </el-table-column>
                        <el-table-column
                            header-align="center"
                            align="center"
                            min-width="120"
                            prop="reward_money"
                            label="返现"
                        >
                            <template slot-scope="scope">
                                <el-input
                                    :disabled="scope.row.brand_reward_conf_id != '' && flowCardForm.type == 5"
                                    v-model="scope.row.reward_money"
                                ></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                            header-align="center"
                            align="center"
                            min-width="150"
                            prop="status"
                            label="状态"
                        >
                            <template slot-scope="scope">
                                <el-switch
                                    v-model="scope.row.status"
                                    active-text="展示"
                                    :active-value="1"
                                    inactive-text="隐藏"
                                    :inactive-value="0"
                                    @change="handleSwitch(scope.row,scope.$index)"
                                ></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column
                            header-align="center"
                            align="center"
                            min-width="120"
                            label="操作"
                        >
                            <template slot-scope="scope">
                                <el-button
                                    v-if="scope.$index != 0"
                                    :disabled="scope.row.brand_reward_conf_id != '' && flowCardForm.type == 5"
                                    @click="handleDel(scope.row,scope.$index)"
                                    type="text"
                                    size="small"
                                >删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <!-- <el-form-item v-if="setting.length < 30">
                    <el-button
                        type="text"
                        icon="el-icon-plus"
                        @click="handleAdd"
                    >增加模板</el-button>
                </el-form-item> -->
                <el-form-item label="是否支持层层返现：">
                    <el-radio
                        :disabled="flowCardForm.type == 5"
                        v-model="flowCardForm.is_layer"
                        :label="1"
                    >是</el-radio>
                    <el-radio
                        :disabled="flowCardForm.type == 5"
                        v-model="flowCardForm.is_layer"
                        :label="0"
                    >否</el-radio>
                </el-form-item>
                <el-form-item label="扣费方式：">
                    <el-radio
                        :disabled="flowCardForm.type == 5"
                        v-model="flowCardForm.begain_pay"
                        :label="1"
                    >首年</el-radio>
                    <el-radio
                        :disabled="flowCardForm.type == 5"
                        v-model="flowCardForm.begain_pay"
                        :label="2"
                    >次年</el-radio>
                </el-form-item>
              <el-form :inline="true">
                <!--<el-form-item>
                <el-date-picker
                    size="medium"
                    v-model="flowCardForm.cut_off_time"
                    type="date"
                    placeholder="活动开始时间"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    :disabled="flowCardForm.type == 5"
                ></el-date-picker>
                </el-form-item>-->
                <el-form-item>
                首笔交易(包含押金交易)隔
                  <el-input
                      size="medium"
                      :style="{width:100+'px'}"
                      v-model="flowCardForm.delay_day"
                      :disabled="flowCardForm.type == 5"
                      placeholder="天数"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <span class="line">天以后开始扣费</span>
                </el-form-item>
              </el-form>

                <el-form-item label="APP提示语设置">
                    <el-input
                        v-model="flowCardForm.tips"
                        size="medium"
                        :disabled="flowCardForm.type == 5"
                    ></el-input>
                </el-form-item>
                <el-form-item style="margin-top:20px;">
                    <el-button
                        type="primary"
                        @click="handleSubmit"
                    >提 交</el-button>
                    <div style="margin-top:10px">
                        <el-tag type="danger">温馨提示：模版最多配置30条，展示的最多为6条，且模版配置成功后，不能修改金额。</el-tag>
                    </div>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "MAM_flowCard",
    props: {
        flowCard: {
            type: Object
        },
        brandId: {
            type: [String, Number]
        }
    },
    data() {
        return {
            pickerOptions: { //禁止选之前的时间
                disabledDate(time) {
                    return time.getTime() < Date.now();
                }
            },
            setting: [],
            flowCardForm: {
            },
            comm_fee_list:[],
        };
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        changeFee(val,row){
            row.target_money = val.depositAmt;
            row.fee_rule_id = val.ruleId;  
        },
        handleSubmit() { //提交
            let that = this;
            this.flowCardForm.setting = JSON.stringify(this.setting);
            this.flowCardForm.brand_id = this.brandId;
            this.$confirm('活动配置完成后,“奖励条件”将不能进行修改,请确认是否添加？', '提示', {
                confirmButtonText: '确 认',
                cancelButtonText: '取 消',
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        this.$api.post('brand/flowCardupdate', this.flowCardForm, res => {
                            if (res.code == 0) {
                                this.$message.success({
                                    type: 'success',
                                    message: res.msg,
                                    duration: 1500,
                                    onClose() {
                                        done();
                                        that.handleClose(1);
                                        instance.confirmButtonLoading = false;
                                    }
                                });
                            } else {
                                this.$message.error(res.msg);
                                done();
                                instance.confirmButtonLoading = false;
                            }
                        });
                    } else {
                        done();
                        instance.confirmButtonLoading = false;
                    }
                }
            }).then(() => {

            }).catch(() => { });
        },
        handleAdd() { //增加交易量奖励规则
            this.setting.push({
                brand_reward_conf_id: "",
                target_money: "",
                reward_money: "",
                status: 0,
                is_default: 0,
            });
        },
        handleSwitch(row) {
            if (row.is_default == 1) {
                row.status = 1;
                this.$message.error('默认值不允许隐藏');
            }
        },
        handleDel(row, index) { //删除
            this.$confirm('确定删除该模板吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.setting.splice(index, 1);
            }).catch(() => {

            })
        },
        handleDefault(mark) { //处理勾选时默认值
            this._.forEach(this.setting, item => {
                item.is_default = 0;
            })
            this.setting[mark].is_default = 1;
        },
        handleClose(ref) { //关闭弹窗
            this.$emit('flowCardClose', ref)
        },
        getInfo() { //初始化
            this.$api.post('brand/flowCarddetail', { brand_id: this.brandId }, res => {
                if (res.code === 0) {
                    let data = res.data;
                    this.flowCardForm = data;
                    this.setting = data.setting;
                    this.comm_fee_list = data.comm_fee_list;
                } else {
                    this.$message.error(res.msg);
                }
            })
        }
    }
};
</script>

<style scoped lang="scss">
.MAM_flowCard * {
    font-size: 12px;
    // .el-input__inner {
    //     font-size: 12px;
    // }
    ::v-deep .el-dialog__body {
        height: 600px;
        overflow: auto;
    }
    ::v-deep .el-form-item {
        margin-bottom: 5px;
        .el-form-item__label,
        .el-radio__label {
            font-size: 12px;
        }
    }
    .el-form--label-top ::v-deep .el-form-item__label {
        padding: 0;
    }
    .el-checkbox ::v-deep .el-checkbox__label {
        font-size: 12px;
    }
}
</style>